// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern MCQ Assessment Page */

.mcqMainDiv {
    min-height: calc(100vh - 70px);
    padding: 40px 60px;
    background: #ffffff;
    margin-top: 70px;
}

/* Main Container */
.mcqContainer {
    display: grid;
    grid-template-columns: 1fr 320px;
    gap: 24px;
    max-width: 1600px;
    margin: 0 auto;
}

/* Question Section */
.mcqQuestionSection {
    display: flex;
    flex-direction: column;
}

.mcqQuestionCard {
    background: #ffffff !important;
    border: 1px solid rgba(102, 126, 234, 0.1) !important;
    border-radius: 20px !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08) !important;
    transition: all 0.3s ease !important;
}

.mcqQuestionCard:hover {
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12) !important;
}

.mcqQuestionCard .ant-card-body {
    padding: 32px !important;
}

/* Question Header */
.mcqQuestionHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    flex-wrap: wrap;
    gap: 16px;
}

.mcqQuestionHeaderLeft {
    display: flex;
    align-items: center;
    gap: 16px;
}

.mcqQuestionNumberBadge {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 20px;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
    border: 1px solid rgba(102, 126, 234, 0.2);
    border-radius: 12px;
}

.mcqQuestionIcon {
    font-size: 24px !important;
    color: #667eea !important;
}

.mcqQuestionNumber {
    font-size: 16px;
    font-weight: 600;
    color: #1f2937;
}

.mcqTimerBadge {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    background: linear-gradient(135deg, rgba(245, 87, 108, 0.1) 0%, rgba(239, 68, 68, 0.1) 100%);
    border: 1px solid rgba(245, 87, 108, 0.2);
    border-radius: 12px;
}

.mcqTimerIcon {
    font-size: 20px !important;
    color: #f5576c !important;
}

.mcqTimerText {
    font-size: 16px;
    font-weight: 600;
    color: #f5576c;
    font-variant-numeric: tabular-nums;
}

/* Progress Bar */
.mcqProgressBar {
    margin-bottom: 32px;
}

.mcqProgressBar .ant-progress-bg {
    border-radius: 10px;
}

/* Question Content */
.mcqQuestionContent {
    margin-bottom: 32px;
}

.mcqQuestionText {
    font-size: 18px;
    line-height: 1.8;
    color: #1f2937;
    margin-bottom: 32px;
    font-weight: 500;
}

.mcqQuestionText img {
    max-width: 100%;
    height: auto;
    border-radius: 12px;
    margin: 16px 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Options Container */
.mcqOptionsContainer {
    margin-top: 24px;
}

.mcqTextInput {
    border-radius: 12px !important;
    padding: 12px 16px !important;
    font-size: 16px !important;
    border: 2px solid rgba(102, 126, 234, 0.2) !important;
    transition: all 0.3s ease !important;
}

.mcqTextInput:focus,
.mcqTextInput:hover {
    border-color: #667eea !important;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;
}

.mcqRadioGroup,
.mcqCheckboxGroup {
    width: 100%;
}

.mcqOptionItem {
    padding: 16px 20px;
    border: 2px solid rgba(0, 0, 0, 0.06);
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    background: #ffffff;
    margin-bottom: 12px;
}

.mcqOptionItem:hover {
    border-color: rgba(102, 126, 234, 0.4);
    background: rgba(102, 126, 234, 0.05);
    transform: translateX(4px);
}

.mcqOptionItem.radioOption {
    display: flex;
    align-items: center;
}

.mcqOptionItem.checkboxOption {
    display: flex;
    align-items: flex-start;
}

.mcqRadio,
.mcqCheckbox {
    margin: 0 !important;
    width: 100%;
}

.mcqRadio .ant-radio-inner,
.mcqCheckbox .ant-checkbox-inner {
    width: 22px;
    height: 22px;
    border-color: #667eea;
}

.mcqRadio .ant-radio-checked .ant-radio-inner,
.mcqCheckbox .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #667eea;
    border-color: #667eea;
}

.mcqOptionText {
    font-size: 16px;
    color: #1f2937;
    line-height: 1.6;
    margin-left: 12px;
}

/* Navigation Buttons */
.mcqNavigationButtons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    padding-top: 24px;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.mcqNavButton {
    height: 48px !important;
    padding: 0 32px !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    border-radius: 12px !important;
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    transition: all 0.3s ease !important;
}

.mcqNavButton.prevButton {
    background: #ffffff !important;
    border: 2px solid rgba(102, 126, 234, 0.3) !important;
    color: #667eea !important;
}

.mcqNavButton.prevButton:hover {
    background: rgba(102, 126, 234, 0.05) !important;
    border-color: #667eea !important;
    transform: translateX(-2px);
}

.mcqNavButton.nextButton,
.mcqNavButton.finishButton {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    border: none !important;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4) !important;
}

.mcqNavButton.nextButton:hover,
.mcqNavButton.finishButton:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5) !important;
}

.mcqNavButton.finishButton {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
    box-shadow: 0 4px 15px rgba(16, 185, 129, 0.4) !important;
}

.mcqNavButton.finishButton:hover {
    box-shadow: 0 6px 20px rgba(16, 185, 129, 0.5) !important;
}

/* Sidebar Section */
.mcqSidebarSection {
    display: flex;
    flex-direction: column;
}

.mcqSidebarCard {
    background: #ffffff !important;
    border: 1px solid rgba(102, 126, 234, 0.1) !important;
    border-radius: 20px !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08) !important;
    position: sticky;
    top: 90px;
}

.mcqSidebarCard .ant-card-body {
    padding: 24px !important;
}

.mcqSidebarHeader {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.mcqSidebarIcon {
    font-size: 24px !important;
    color: #667eea !important;
}

.mcqSidebarTitle {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
}

/* Question Chart */
.mcqQuestionChart {
    margin-bottom: 24px;
}

.mcqQuestionChartRow {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
    /* flex-wrap: wrap; */
}

.mcqQuestionNumberItem {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 2px solid rgba(0, 0, 0, 0.1);
    background: #ffffff;
    color: #1f2937;
}

.mcqQuestionNumberItem:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.mcqQuestionNumberItem.selected {
    border-color: #667eea;
    background: rgba(102, 126, 234, 0.1);
    color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}

.mcqQuestionNumberItem.answered {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    border-color: #10b981;
    color: #ffffff;
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.mcqQuestionNumberItem.viewedUnanswered {
    background: linear-gradient(135deg, #f5576c 0%, #ef4444 100%);
    border-color: #f5576c;
    color: #ffffff;
    box-shadow: 0 4px 12px rgba(245, 87, 108, 0.3);
}

.mcqQuestionNumberItem.unanswered {
    background: #f9fafb;
    border-color: #e5e7eb;
    color: #6b7280;
}

/* Legend */
.mcqLegend {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 24px;
    padding: 16px;
    background: rgba(102, 126, 234, 0.05);
    border-radius: 12px;
}

.mcqLegendItem {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 13px;
    color: #4b5563;
}

.mcqLegendColor {
    width: 20px;
    height: 20px;
    border-radius: 6px;
    flex-shrink: 0;
}

.mcqLegendColor.answered {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.mcqLegendColor.viewedUnanswered {
    background: linear-gradient(135deg, #f5576c 0%, #ef4444 100%);
}

.mcqLegendColor.unanswered {
    background: #e5e7eb;
    border: 1px solid #d1d5db;
}

/* Timer Card */
.mcqTimerCard {
    background: linear-gradient(135deg, rgba(245, 87, 108, 0.1) 0%, rgba(239, 68, 68, 0.1) 100%);
    border: 1px solid rgba(245, 87, 108, 0.2);
    border-radius: 12px;
    padding: 20px;
}

.mcqTimerContent {
    display: flex;
    align-items: center;
    gap: 16px;
}

.mcqTimerLargeIcon {
    font-size: 32px !important;
    color: #f5576c !important;
}

.mcqTimerInfo {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.mcqTimerLabel {
    font-size: 12px;
    color: #6b7280;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.mcqTimerValue {
    font-size: 24px;
    font-weight: 700;
    color: #f5576c;
    font-variant-numeric: tabular-nums;
}

/* No Questions */
.mcqNoQuestions {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    text-align: center;
}

.mcqNoQuestions h3 {
    font-size: 24px;
    color: #6b7280;
    margin: 0;
}

/* Legacy Styles (for compatibility) */
.questionCard {
    display: none;
}

.questionParagraphinmcq {
    display: none;
}

.QuestionHeader {
    display: none;
}

.Ques-txt {
    display: none;
}

.timer-container {
    display: none;
}

/* Responsive Design */
@media (max-width: 1200px) {
    .mcqMainDiv {
        padding: 30px 40px;
    }

    .mcqContainer {
        grid-template-columns: 1fr 280px;
        gap: 20px;
    }
}

@media (max-width: 968px) {
    .mcqContainer {
        grid-template-columns: 1fr;
    }

    .mcqSidebarCard {
        position: relative;
        top: 0;
        order: -1;
    }

    .mcqQuestionChartRow {
        justify-content: center;
    }
}

@media (max-width: 768px) {
    .mcqMainDiv {
        padding: 30px 20px;
    }

    .mcqQuestionCard .ant-card-body,
    .mcqSidebarCard .ant-card-body {
        padding: 24px !important;
    }

    .mcqQuestionHeader {
        flex-direction: column;
        align-items: flex-start;
    }

    .mcqQuestionText {
        font-size: 16px;
    }

    .mcqOptionItem {
        padding: 14px 16px;
    }

    .mcqOptionText {
        font-size: 15px;
    }

    .mcqNavigationButtons {
        flex-direction: column;
    }

    .mcqNavButton {
        width: 100% !important;
        justify-content: center !important;
    }

    .mcqQuestionNumberItem {
        width: 44px;
        height: 44px;
        font-size: 14px;
    }
}

@media (max-width: 480px) {
    .mcqMainDiv {
        padding: 20px 16px;
    }

    .mcqQuestionNumberBadge,
    .mcqTimerBadge {
        padding: 8px 16px;
    }

    .mcqQuestionNumber,
    .mcqTimerText {
        font-size: 14px;
    }

    .mcqTimerValue {
        font-size: 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Courses/Assessment/MCQ/Mcq.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,qDAAqD;IACrD,8BAA8B;IAC9B,qDAAqD;IACrD,oCAAoC;AACxC;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,8FAA8F;IAC9F,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,4FAA4F;IAC5F,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kCAAkC;AACtC;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,yCAAyC;AAC7C;;AAEA,sBAAsB;AACtB;IACI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,0BAA0B;IAC1B,qDAAqD;IACrD,oCAAoC;AACxC;;AAEA;;IAEI,gCAAgC;IAChC,yDAAyD;AAC7D;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;;IAEI,oBAAoB;IACpB,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,qDAAqD;IACrD,yBAAyB;AAC7B;;AAEA;IACI,gDAAgD;IAChD,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;;IAEI,wEAAwE;IACxE,uBAAuB;IACvB,0DAA0D;AAC9D;;AAEA;;IAEI,2BAA2B;IAC3B,0DAA0D;AAC9D;;AAEA;IACI,wEAAwE;IACxE,yDAAyD;AAC7D;;AAEA;IACI,yDAAyD;AAC7D;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,qDAAqD;IACrD,8BAA8B;IAC9B,qDAAqD;IACrD,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,oBAAoB;IACpB,4CAA4C;AAChD;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA,mBAAmB;AACnB;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,oCAAoC;IACpC,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,+CAA+C;AACnD;;AAEA;IACI,qBAAqB;IACrB,oCAAoC;IACpC,cAAc;IACd,8CAA8C;AAClD;;AAEA;IACI,6DAA6D;IAC7D,qBAAqB;IACrB,cAAc;IACd,8CAA8C;AAClD;;AAEA;IACI,6DAA6D;IAC7D,qBAAqB;IACrB,cAAc;IACd,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA,eAAe;AACf;IACI,4FAA4F;IAC5F,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kCAAkC;AACtC;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA,sCAAsC;AACtC;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA,sBAAsB;AACtB;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,gCAAgC;QAChC,SAAS;IACb;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;QAClB,MAAM;QACN,SAAS;IACb;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;;QAEI,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,kCAAkC;IACtC;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* Modern MCQ Assessment Page */\n\n.mcqMainDiv {\n    min-height: calc(100vh - 70px);\n    padding: 40px 60px;\n    background: #ffffff;\n    margin-top: 70px;\n}\n\n/* Main Container */\n.mcqContainer {\n    display: grid;\n    grid-template-columns: 1fr 320px;\n    gap: 24px;\n    max-width: 1600px;\n    margin: 0 auto;\n}\n\n/* Question Section */\n.mcqQuestionSection {\n    display: flex;\n    flex-direction: column;\n}\n\n.mcqQuestionCard {\n    background: #ffffff !important;\n    border: 1px solid rgba(102, 126, 234, 0.1) !important;\n    border-radius: 20px !important;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08) !important;\n    transition: all 0.3s ease !important;\n}\n\n.mcqQuestionCard:hover {\n    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12) !important;\n}\n\n.mcqQuestionCard .ant-card-body {\n    padding: 32px !important;\n}\n\n/* Question Header */\n.mcqQuestionHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n    flex-wrap: wrap;\n    gap: 16px;\n}\n\n.mcqQuestionHeaderLeft {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.mcqQuestionNumberBadge {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 20px;\n    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);\n    border: 1px solid rgba(102, 126, 234, 0.2);\n    border-radius: 12px;\n}\n\n.mcqQuestionIcon {\n    font-size: 24px !important;\n    color: #667eea !important;\n}\n\n.mcqQuestionNumber {\n    font-size: 16px;\n    font-weight: 600;\n    color: #1f2937;\n}\n\n.mcqTimerBadge {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 20px;\n    background: linear-gradient(135deg, rgba(245, 87, 108, 0.1) 0%, rgba(239, 68, 68, 0.1) 100%);\n    border: 1px solid rgba(245, 87, 108, 0.2);\n    border-radius: 12px;\n}\n\n.mcqTimerIcon {\n    font-size: 20px !important;\n    color: #f5576c !important;\n}\n\n.mcqTimerText {\n    font-size: 16px;\n    font-weight: 600;\n    color: #f5576c;\n    font-variant-numeric: tabular-nums;\n}\n\n/* Progress Bar */\n.mcqProgressBar {\n    margin-bottom: 32px;\n}\n\n.mcqProgressBar .ant-progress-bg {\n    border-radius: 10px;\n}\n\n/* Question Content */\n.mcqQuestionContent {\n    margin-bottom: 32px;\n}\n\n.mcqQuestionText {\n    font-size: 18px;\n    line-height: 1.8;\n    color: #1f2937;\n    margin-bottom: 32px;\n    font-weight: 500;\n}\n\n.mcqQuestionText img {\n    max-width: 100%;\n    height: auto;\n    border-radius: 12px;\n    margin: 16px 0;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n/* Options Container */\n.mcqOptionsContainer {\n    margin-top: 24px;\n}\n\n.mcqTextInput {\n    border-radius: 12px !important;\n    padding: 12px 16px !important;\n    font-size: 16px !important;\n    border: 2px solid rgba(102, 126, 234, 0.2) !important;\n    transition: all 0.3s ease !important;\n}\n\n.mcqTextInput:focus,\n.mcqTextInput:hover {\n    border-color: #667eea !important;\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;\n}\n\n.mcqRadioGroup,\n.mcqCheckboxGroup {\n    width: 100%;\n}\n\n.mcqOptionItem {\n    padding: 16px 20px;\n    border: 2px solid rgba(0, 0, 0, 0.06);\n    border-radius: 12px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    background: #ffffff;\n    margin-bottom: 12px;\n}\n\n.mcqOptionItem:hover {\n    border-color: rgba(102, 126, 234, 0.4);\n    background: rgba(102, 126, 234, 0.05);\n    transform: translateX(4px);\n}\n\n.mcqOptionItem.radioOption {\n    display: flex;\n    align-items: center;\n}\n\n.mcqOptionItem.checkboxOption {\n    display: flex;\n    align-items: flex-start;\n}\n\n.mcqRadio,\n.mcqCheckbox {\n    margin: 0 !important;\n    width: 100%;\n}\n\n.mcqRadio .ant-radio-inner,\n.mcqCheckbox .ant-checkbox-inner {\n    width: 22px;\n    height: 22px;\n    border-color: #667eea;\n}\n\n.mcqRadio .ant-radio-checked .ant-radio-inner,\n.mcqCheckbox .ant-checkbox-checked .ant-checkbox-inner {\n    background-color: #667eea;\n    border-color: #667eea;\n}\n\n.mcqOptionText {\n    font-size: 16px;\n    color: #1f2937;\n    line-height: 1.6;\n    margin-left: 12px;\n}\n\n/* Navigation Buttons */\n.mcqNavigationButtons {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n    padding-top: 24px;\n    border-top: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.mcqNavButton {\n    height: 48px !important;\n    padding: 0 32px !important;\n    font-size: 16px !important;\n    font-weight: 600 !important;\n    border-radius: 12px !important;\n    display: flex !important;\n    align-items: center !important;\n    gap: 8px !important;\n    transition: all 0.3s ease !important;\n}\n\n.mcqNavButton.prevButton {\n    background: #ffffff !important;\n    border: 2px solid rgba(102, 126, 234, 0.3) !important;\n    color: #667eea !important;\n}\n\n.mcqNavButton.prevButton:hover {\n    background: rgba(102, 126, 234, 0.05) !important;\n    border-color: #667eea !important;\n    transform: translateX(-2px);\n}\n\n.mcqNavButton.nextButton,\n.mcqNavButton.finishButton {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n    border: none !important;\n    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4) !important;\n}\n\n.mcqNavButton.nextButton:hover,\n.mcqNavButton.finishButton:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5) !important;\n}\n\n.mcqNavButton.finishButton {\n    background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;\n    box-shadow: 0 4px 15px rgba(16, 185, 129, 0.4) !important;\n}\n\n.mcqNavButton.finishButton:hover {\n    box-shadow: 0 6px 20px rgba(16, 185, 129, 0.5) !important;\n}\n\n/* Sidebar Section */\n.mcqSidebarSection {\n    display: flex;\n    flex-direction: column;\n}\n\n.mcqSidebarCard {\n    background: #ffffff !important;\n    border: 1px solid rgba(102, 126, 234, 0.1) !important;\n    border-radius: 20px !important;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08) !important;\n    position: sticky;\n    top: 90px;\n}\n\n.mcqSidebarCard .ant-card-body {\n    padding: 24px !important;\n}\n\n.mcqSidebarHeader {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 24px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.mcqSidebarIcon {\n    font-size: 24px !important;\n    color: #667eea !important;\n}\n\n.mcqSidebarTitle {\n    font-size: 18px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0;\n}\n\n/* Question Chart */\n.mcqQuestionChart {\n    margin-bottom: 24px;\n}\n\n.mcqQuestionChartRow {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 10px;\n    /* flex-wrap: wrap; */\n}\n\n.mcqQuestionNumberItem {\n    width: 48px;\n    height: 48px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 12px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    border: 2px solid rgba(0, 0, 0, 0.1);\n    background: #ffffff;\n    color: #1f2937;\n}\n\n.mcqQuestionNumberItem:hover {\n    transform: scale(1.1);\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.mcqQuestionNumberItem.selected {\n    border-color: #667eea;\n    background: rgba(102, 126, 234, 0.1);\n    color: #667eea;\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);\n}\n\n.mcqQuestionNumberItem.answered {\n    background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n    border-color: #10b981;\n    color: #ffffff;\n    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n}\n\n.mcqQuestionNumberItem.viewedUnanswered {\n    background: linear-gradient(135deg, #f5576c 0%, #ef4444 100%);\n    border-color: #f5576c;\n    color: #ffffff;\n    box-shadow: 0 4px 12px rgba(245, 87, 108, 0.3);\n}\n\n.mcqQuestionNumberItem.unanswered {\n    background: #f9fafb;\n    border-color: #e5e7eb;\n    color: #6b7280;\n}\n\n/* Legend */\n.mcqLegend {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-bottom: 24px;\n    padding: 16px;\n    background: rgba(102, 126, 234, 0.05);\n    border-radius: 12px;\n}\n\n.mcqLegendItem {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 13px;\n    color: #4b5563;\n}\n\n.mcqLegendColor {\n    width: 20px;\n    height: 20px;\n    border-radius: 6px;\n    flex-shrink: 0;\n}\n\n.mcqLegendColor.answered {\n    background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n}\n\n.mcqLegendColor.viewedUnanswered {\n    background: linear-gradient(135deg, #f5576c 0%, #ef4444 100%);\n}\n\n.mcqLegendColor.unanswered {\n    background: #e5e7eb;\n    border: 1px solid #d1d5db;\n}\n\n/* Timer Card */\n.mcqTimerCard {\n    background: linear-gradient(135deg, rgba(245, 87, 108, 0.1) 0%, rgba(239, 68, 68, 0.1) 100%);\n    border: 1px solid rgba(245, 87, 108, 0.2);\n    border-radius: 12px;\n    padding: 20px;\n}\n\n.mcqTimerContent {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.mcqTimerLargeIcon {\n    font-size: 32px !important;\n    color: #f5576c !important;\n}\n\n.mcqTimerInfo {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.mcqTimerLabel {\n    font-size: 12px;\n    color: #6b7280;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.mcqTimerValue {\n    font-size: 24px;\n    font-weight: 700;\n    color: #f5576c;\n    font-variant-numeric: tabular-nums;\n}\n\n/* No Questions */\n.mcqNoQuestions {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 400px;\n    text-align: center;\n}\n\n.mcqNoQuestions h3 {\n    font-size: 24px;\n    color: #6b7280;\n    margin: 0;\n}\n\n/* Legacy Styles (for compatibility) */\n.questionCard {\n    display: none;\n}\n\n.questionParagraphinmcq {\n    display: none;\n}\n\n.QuestionHeader {\n    display: none;\n}\n\n.Ques-txt {\n    display: none;\n}\n\n.timer-container {\n    display: none;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n    .mcqMainDiv {\n        padding: 30px 40px;\n    }\n\n    .mcqContainer {\n        grid-template-columns: 1fr 280px;\n        gap: 20px;\n    }\n}\n\n@media (max-width: 968px) {\n    .mcqContainer {\n        grid-template-columns: 1fr;\n    }\n\n    .mcqSidebarCard {\n        position: relative;\n        top: 0;\n        order: -1;\n    }\n\n    .mcqQuestionChartRow {\n        justify-content: center;\n    }\n}\n\n@media (max-width: 768px) {\n    .mcqMainDiv {\n        padding: 30px 20px;\n    }\n\n    .mcqQuestionCard .ant-card-body,\n    .mcqSidebarCard .ant-card-body {\n        padding: 24px !important;\n    }\n\n    .mcqQuestionHeader {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .mcqQuestionText {\n        font-size: 16px;\n    }\n\n    .mcqOptionItem {\n        padding: 14px 16px;\n    }\n\n    .mcqOptionText {\n        font-size: 15px;\n    }\n\n    .mcqNavigationButtons {\n        flex-direction: column;\n    }\n\n    .mcqNavButton {\n        width: 100% !important;\n        justify-content: center !important;\n    }\n\n    .mcqQuestionNumberItem {\n        width: 44px;\n        height: 44px;\n        font-size: 14px;\n    }\n}\n\n@media (max-width: 480px) {\n    .mcqMainDiv {\n        padding: 20px 16px;\n    }\n\n    .mcqQuestionNumberBadge,\n    .mcqTimerBadge {\n        padding: 8px 16px;\n    }\n\n    .mcqQuestionNumber,\n    .mcqTimerText {\n        font-size: 14px;\n    }\n\n    .mcqTimerValue {\n        font-size: 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
